import { CdsAutocomplete } from '@chicksgroup/web-components';
import { bindable, capture, EventAggregator, ICustomElementViewModel, inject } from 'aurelia';
import { Helper } from '../../extensions';

@inject(Element, EventAggregator, Helper)
@capture()
export class DbAutocompleteFilter implements ICustomElementViewModel {
    dbAutocompleteFilter: CdsAutocomplete;
    selectedItems = [];
    private isDefaultSelected = true;
    @bindable label: string;
    @bindable items: any[];
    @bindable autoClear = true;

    constructor(private element: Element, private eventAggregator: EventAggregator, private helper: Helper) {
        this.element = element;
        this.eventAggregator = eventAggregator;
        this.helper = helper;
    }

    attached() {
        this.handleEventAggregator();
        this.buildOptions();

        if (this.autoClear) {
            this.eventAggregator.subscribe('clear-filters', this.handleClearFiltersEvent);
        }
    }

    buildOptions() {
        if (Array.isArray(this.items) && this.dbAutocompleteFilter) {
            setTimeout(() => (this.dbAutocompleteFilter.items = this.items?.map((item, i) => ({ ...item, selected: i === 0 }))));
        }
    }

    itemsChanged() {
        this.buildOptions();
    }

    handleItemSelected(event: CustomEvent): void {
        this.selectedItems = [];
        const selectedDetail = event.detail;
        const selectedLabel = selectedDetail?.label || selectedDetail?.value;
        const selectedValue = selectedDetail?.selected?.value ?? selectedDetail?.value;
        this.isDefaultSelected = selectedValue === this.items?.at(0)?.value || selectedLabel === this.items?.at(0)?.label;
        this.selectedItems = this.selectedItems.concat(selectedLabel);
        this.dispatchEvent(event.detail);
    }

    dispatchEvent(detail) {
        const dispatchEvent = new CustomEvent('itemselected', {
            detail,
            bubbles: true,
            composed: true
        });

        this.element.dispatchEvent(dispatchEvent);
    }

    handleClearFiltersEvent = () => {
        if (this.isDefaultSelected) return;
        this.buildOptions();
    };

    handleEventAggregator() {
        this.helper.debounce(this, 'eventHandler', 'eventHandlerTimeout', 600, () => {
            this.eventAggregator.subscribe('clear-all-filters', () => {
                this.dbAutocompleteFilter?.setValue(this.items?.at(0)?.label);
                this.dbAutocompleteFilter?.selectItem(0);
            });
        });
    }
}
